import { MutableRefObject, useLayoutEffect } from 'react';

export const useOutsideClickDetection = (
  wrapperRef: MutableRefObject<HTMLElement | null>,
  setIsVisible?: (value: ((prevState: boolean) => boolean) | boolean) => void,
): void => {
  useLayoutEffect(() => {
    let drag = false;
    const handleMouseDown = () => (drag = false);
    const handleMouseMove = () => (drag = true);
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', () =>
      drag
        ? document.removeEventListener('click', handleClickOutside, false)
        : document.addEventListener('click', handleClickOutside, false),
    );

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event: MouseEvent) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target as HTMLElement)) {
      setIsVisible?.(false);
    }
  };
};
